import type { Period } from "../lib/dateRange";

interface PeriodSwitcherProps {
  period: Period;
  onChange: (p: Period) => void;
  customStart: string;
  customEnd: string;
  onCustomStartChange: (v: string) => void;
  onCustomEndChange: (v: string) => void;
}

const OPTIONS: { value: Period; label: string }[] = [
  { value: "7d", label: "7日" },
  { value: "30d", label: "30日" },
  { value: "90d", label: "90日" },
  { value: "custom", label: "カスタム" },
];

export function PeriodSwitcher({
  period,
  onChange,
  customStart,
  customEnd,
  onCustomStartChange,
  onCustomEndChange,
}: PeriodSwitcherProps) {
  return (
    <div>
      <div className="period-row">
        {OPTIONS.map((o) => (
          <button
            key={o.value}
            className={`period-btn ${period === o.value ? "active" : ""}`}
            onClick={() => onChange(o.value)}
          >
            {o.label}
          </button>
        ))}
      </div>
      {period === "custom" && (
        <div className="custom-range">
          <input
            type="date"
            value={customStart}
            onChange={(e) => onCustomStartChange(e.target.value)}
            aria-label="開始日"
          />
          <span>〜</span>
          <input
            type="date"
            value={customEnd}
            onChange={(e) => onCustomEndChange(e.target.value)}
            aria-label="終了日"
          />
        </div>
      )}
    </div>
  );
}
